/* Ozarke — Tabs Section (Specifications / Features) — SPA-safe
   - Works even when the PDP is loaded via AJAX/page transitions.
   - Uses event delegation (no per-section script execution needed).
   - Tries to nudge lazy-loaded images inside a newly-shown panel.
*/
(function () {
  if (window.__ozarkeTabsDelegateBound) return;
  window.__ozarkeTabsDelegateBound = true;

  function qsa(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function getSection(el) {
    return el && el.closest ? el.closest('.tabs-section') : null;
  }

  function getButtons(section) {
    return qsa(section, '.tabs-section__tab-button');
  }

  function getPanels(section) {
    return qsa(section, '.tabs-section__panel');
  }

  function updateUnderline(section) {
    var underline = section.querySelector('.tabs-section__nav-underline');
    if (!underline) return;

    var buttons = getButtons(section);
    if (!buttons.length) return;

    var active = section.querySelector('.tabs-section__tab-button--active') || buttons[0];
    var idx = buttons.indexOf(active);
    if (idx < 0) idx = 0;

    var tabWidth = 100 / buttons.length;
    underline.style.left = idx * tabWidth + '%';
    underline.style.width = tabWidth + '%';
  }

  function nudgeLazyMedia(panel) {
    if (!panel) return;

    // Ozarke "preload-v2" pattern (used in Specifications):
    // <img class="preload-v2" data-preload-desktop="..." data-preload-mobile="..."> (no src on first AJAX load)
    // The original inline script relied on DOMContentLoaded, which doesn't fire for HTML injected via transitions.
    var TABLET_BREAKPOINT = 768; // keep in sync with the inline helper
    var isMobile = (window.innerWidth || 1024) < TABLET_BREAKPOINT;

    // Common lazy patterns: data-src / data-srcset
    var imgs = qsa(panel, 'img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];

      // Handle preload-v2 first
      if (img.classList && img.classList.contains('preload-v2')) {
        var mobileSrc = img.getAttribute('data-preload-mobile');
        var desktopSrc = img.getAttribute('data-preload-desktop');
        var targetSrc = isMobile ? mobileSrc : desktopSrc;
        var currentSrc = img.getAttribute('src') || '';
        if (targetSrc && currentSrc !== targetSrc) {
          img.setAttribute('src', targetSrc);
        }
      }
      var dataSrc = img.getAttribute('data-src');
      var dataSrcset = img.getAttribute('data-srcset');
      var src = img.getAttribute('src') || '';
      var srcset = img.getAttribute('srcset') || '';
      var isPlaceholder = src.indexOf('data:image') === 0 || src === '';
      var looksLazy = (img.classList && (img.classList.contains('lazyload') || img.classList.contains('lazy'))) || false;

      // If the image is lazy/placeholder, force its real source.
      if (dataSrc && (isPlaceholder || looksLazy)) {
        img.setAttribute('src', dataSrc);
      }
      if (dataSrcset && (srcset === '' || looksLazy)) {
        img.setAttribute('srcset', dataSrcset);
      }

      // If the tab panel is visible, try to load eagerly.
      try {
        img.setAttribute('loading', 'eager');
      } catch (e0) {}
    }

    // <source data-srcset>
    var sources = qsa(panel, 'source[data-srcset]');
    for (var s = 0; s < sources.length; s++) {
      var source = sources[s];
      if (!source.getAttribute('srcset')) {
        source.setAttribute('srcset', source.getAttribute('data-srcset'));
      }
    }

    // If a lazy loader exists globally, ask it to re-scan
    try {
      if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.checkElems === 'function') {
        window.lazySizes.loader.checkElems();
      }
    } catch (e) {}

    // Nudge IntersectionObserver-based loaders
    try {
      window.dispatchEvent(new Event('scroll'));
      window.dispatchEvent(new Event('resize'));
    } catch (e2) {}
  }

  function nudgeActivePanel(section) {
    if (!section) return;
    var panel = section.querySelector('.tabs-section__panel--active');
    if (!panel) {
      var panels = getPanels(section);
      panel = panels && panels.length ? panels[0] : null;
    }
    if (panel) nudgeLazyMedia(panel);
  }

  function initSection(section) {
    if (!section) return;
    updateUnderline(section);
    // IMPORTANT: on first load / AJAX navigation, the active panel may contain lazy media.
    nudgeActivePanel(section);
  }

  function activate(section, index) {
    var buttons = getButtons(section);
    var panels = getPanels(section);
    if (!buttons.length || !panels.length) return;

    if (index < 0) index = 0;
    if (index > buttons.length - 1) index = buttons.length - 1;

    for (var i = 0; i < buttons.length; i++) {
      buttons[i].classList.remove('tabs-section__tab-button--active');
      buttons[i].setAttribute('aria-selected', 'false');
    }
    for (var j = 0; j < panels.length; j++) {
      panels[j].classList.remove('tabs-section__panel--active');
    }

    var btn = buttons[index];
    var panel = panels[index];
    if (btn) {
      btn.classList.add('tabs-section__tab-button--active');
      btn.setAttribute('aria-selected', 'true');
    }
    if (panel) {
      panel.classList.add('tabs-section__panel--active');
      nudgeLazyMedia(panel);
    }

    updateUnderline(section);
  }

  function indexFromButton(btn, section) {
    var dataIdx = btn.getAttribute('data-tab-index');
    if (dataIdx) {
      var parsed = parseInt(dataIdx, 10);
      if (!isNaN(parsed)) return parsed - 1; // your Liquid uses 1-based
    }
    var buttons = getButtons(section);
    return buttons.indexOf(btn);
  }

  // Click delegation
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.tabs-section__tab-button') : null;
    if (!btn) return;

    var section = getSection(btn);
    if (!section) return;

    var idx = indexFromButton(btn, section);
    if (idx >= 0) activate(section, idx);
  });

  // Keyboard support
  document.addEventListener('keydown', function (e) {
    var target = e.target;
    if (!target || !target.classList || !target.classList.contains('tabs-section__tab-button')) return;

    var section = getSection(target);
    if (!section) return;

    var buttons = getButtons(section);
    var current = buttons.indexOf(target);
    if (current < 0) return;

    if (e.key === 'ArrowRight' && current < buttons.length - 1) {
      e.preventDefault();
      activate(section, current + 1);
      buttons[current + 1].focus();
    } else if (e.key === 'ArrowLeft' && current > 0) {
      e.preventDefault();
      activate(section, current - 1);
      buttons[current - 1].focus();
    }
  });

  // Keep underline correct on resize
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var sections = qsa(document, '.tabs-section');
      for (var i = 0; i < sections.length; i++) updateUnderline(sections[i]);
    }, 150);
  });

  // Initial underline pass (covers full page loads)
  function boot() {
    var sections = qsa(document, '.tabs-section');
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // If your theme replaces content via transitions, this catches late-added tabs.
  // (It does not depend on any specific transition library.)
  try {
    var mo = new MutationObserver(function (mutations) {
      var found = [];
      for (var m = 0; m < mutations.length; m++) {
        var added = mutations[m].addedNodes;
        if (!added || !added.length) continue;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (!node || node.nodeType !== 1) continue;
          if (node.matches && node.matches('.tabs-section')) {
            found.push(node);
          } else if (node.querySelector) {
            var inners = node.querySelectorAll ? node.querySelectorAll('.tabs-section') : [];
            if (inners && inners.length) {
              for (var k = 0; k < inners.length; k++) found.push(inners[k]);
            }
          }
        }
      }

      if (found.length) {
        // Batch to next frame so layout has settled.
        try {
          requestAnimationFrame(function () {
            for (var i = 0; i < found.length; i++) initSection(found[i]);
          });
        } catch (e1) {
          for (var i2 = 0; i2 < found.length; i2++) initSection(found[i2]);
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  // Shopify Theme Editor + many transition libs dispatch this when sections get re-rendered.
  document.addEventListener('shopify:section:load', function (evt) {
    try {
      var target = (evt && evt.target) || document;
      var sections = qsa(target, '.tabs-section');
      for (var i = 0; i < sections.length; i++) initSection(sections[i]);
    } catch (e2) {}
  });
})();
